import type { ContainmentGrid, GridElement, GridElementSection } from '../..';
import type { GridElementsLoadFlowDetails } from '../gridElementsDetailsByCalculationType/loadFlow/gridElementLoadFlowDetails.types';
import type { GridElementsShortCircuitDetails } from '../gridElementsDetailsByCalculationType/shortCircuit/ShortCircuitDetails';

export function getContainersWithGridElements(
  containment: ContainmentGrid,
  gridElementsWithEvaluatedLoadFlow: GridElementsLoadFlowDetails,
  gridElementsWithEvaluatedShortCircuit: GridElementsShortCircuitDetails
): GridElementSection<GridElement>[] {
  const gridElements = gridElementsWithEvaluatedLoadFlow
    .map(gridElement => ({
      id: gridElement.id,
      objectType: gridElement.objectType,
      label: gridElement.label,
      title: gridElement.title
    }))
    .concat(
      gridElementsWithEvaluatedShortCircuit.map(gridElement => ({
        id: gridElement.id,
        objectType: gridElement.objectType,
        label: gridElement.label,
        title: gridElement.title
      }))
    );
  return containment.map(
    (containerDetails): GridElementSection<GridElement> => {
      return {
        header: `${containerDetails.containerType || 'Container'} ${
          containerDetails.containerId
        }`,
        type: 'Container',
        gridElements: gridElements
          .filter(gridElement =>
            containerDetails.containedObjects.find(
              containedObject => containedObject.objectId === gridElement.id
            )
          )
          .map(
            (gridElement): GridElement => ({
              objectId: gridElement.id,
              label: gridElement.label,
              title: gridElement.title
            })
          )
      };
    }
  );
}
